import { Component, Input } from '@angular/core';

import { RadioModel }           from './typings/radio';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-radio-group',
  styles: [ require('./radio-group.component.scss') ],
  template: require('./radio-group.component.html')
})
export class RadioGroupComponent extends TextControlComponent {
  _radios : Array<RadioModel> = [];

  @Input() set radios ( _radios : Array<RadioModel> ) {
    this._radios = _radios.map(( radio : RadioModel, index : number ) => {
      radio.order = radio.order || radio.order === 0
        ? radio.order
        : index;

      radio.type = radio.type || 'normal';

      return radio;
    })
    .sort((a, b) => a.order - b.order);
  }

  getRadioClasses ( radio : RadioModel ) : Array<string> {
    const classes : Array<string> = [];

    switch (radio.type) {
      case 'danger':
        classes.push('radio-danger');
        break;
      case 'success':
        classes.push('radio-success');
        break;
      case 'warning':
        classes.push('radio-warning');
        break;
      case 'normal':
      default:
        break;
    }

    return classes;
  }
}
